import NCM from './ncm'

export default class IPI {
  constructor(id, aliquota, descricao, observacao, cst) {
    this.id = id
    this.aliquota = aliquota
    this.descricao = descricao
    this.observacao = observacao
    this.ncm = new NCM()
    this.cst = cst
  }
}
